// ── Premium product image zoom — hover-to-pan + click lightbox ───────────────
(function () {
  var ZOOM_SCALE = 2.5;
  var initialized = new WeakSet();

  // ── Lightbox ──
  var lb = null;
  function getLightbox() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.id = 'sobe-lightbox';
    lb.innerHTML = [
      '<div id="sobe-lb-backdrop"></div>',
      '<div id="sobe-lb-inner">',
      '  <button id="sobe-lb-close" aria-label="Close">&#x2715;</button>',
      '  <button id="sobe-lb-prev" aria-label="Previous">&#x2039;</button>',
      '  <img id="sobe-lb-img" src="" alt="">',
      '  <button id="sobe-lb-next" aria-label="Next">&#x203A;</button>',
      '</div>'
    ].join('');

    var style = document.createElement('style');
    style.textContent = [
      '#sobe-lightbox{position:fixed;inset:0;z-index:9999;display:none;align-items:center;justify-content:center}',
      '#sobe-lightbox.open{display:flex}',
      '#sobe-lb-backdrop{position:absolute;inset:0;background:rgba(0,0,0,.88);cursor:zoom-out}',
      // Inner takes full viewport, arrows absolutely positioned overlays (not flex siblings)
      '#sobe-lb-inner{position:relative;z-index:1;width:100vw;height:100vh;display:flex;align-items:center;justify-content:center}',
      '#sobe-lb-img{max-width:92vw;max-height:86vh;object-fit:contain;border-radius:4px;display:block;transition:opacity .2s}',
      '#sobe-lb-close{position:fixed;top:16px;right:20px;background:rgba(255,255,255,.15);border:none;color:#fff;font-size:22px;width:40px;height:40px;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background .2s;z-index:3}',
      '#sobe-lb-close:hover{background:rgba(255,255,255,.3)}',
      // Arrows as overlays positioned at left/right edges, not in flex flow
      '#sobe-lb-prev,#sobe-lb-next{position:absolute;top:50%;transform:translateY(-50%);background:rgba(255,255,255,.15);border:none;color:#fff;font-size:36px;width:44px;height:44px;border-radius:50%;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background .2s;line-height:1;z-index:2}',
      '#sobe-lb-prev{left:16px}',
      '#sobe-lb-next{right:16px}',
      '#sobe-lb-prev:hover,#sobe-lb-next:hover{background:rgba(255,255,255,.3)}',
      // Mobile: smaller arrows + closer to edges, image takes full width
      '@media (max-width:600px){#sobe-lb-prev,#sobe-lb-next{width:36px;height:36px;font-size:28px}#sobe-lb-prev{left:8px}#sobe-lb-next{right:8px}#sobe-lb-img{max-width:96vw;max-height:80vh}#sobe-lb-close{top:10px;right:10px;width:36px;height:36px;font-size:18px}}',
      '.sobe-zoom-hint{position:absolute;bottom:10px;right:10px;background:rgba(0,0,0,.45);color:#fff;font-size:11px;letter-spacing:.08em;text-transform:uppercase;padding:4px 8px;border-radius:20px;pointer-events:none;opacity:1;transition:opacity .3s;font-family:sans-serif;z-index:3}'
    ].join('');
    document.head.appendChild(style);
    document.body.appendChild(lb);

    document.getElementById('sobe-lb-backdrop').onclick = closeLightbox;
    document.getElementById('sobe-lb-close').onclick   = closeLightbox;
    document.getElementById('sobe-lb-prev').onclick    = function() { shiftLightbox(-1); };
    document.getElementById('sobe-lb-next').onclick    = function() { shiftLightbox(1); };
    document.addEventListener('keydown', function(e) {
      if (!lb.classList.contains('open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft')  shiftLightbox(-1);
      if (e.key === 'ArrowRight') shiftLightbox(1);
    });

    // ── Touch swipe navigation (mobile) ──
    // Swipe left → next image, swipe right → previous. Vertical swipe ignored
    // so we don't fight with pinch-to-zoom or scroll-to-close gestures.
    var inner = document.getElementById('sobe-lb-inner');
    var touchStartX = 0, touchStartY = 0, touchMoved = false;
    var SWIPE_MIN = 50;        // px horizontal delta required
    var SWIPE_MAX_VERT = 80;   // px vertical wobble allowed
    inner.addEventListener('touchstart', function(e) {
      if (e.touches.length !== 1) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchMoved = false;
    }, { passive: true });
    inner.addEventListener('touchmove', function(e) {
      touchMoved = true;
    }, { passive: true });
    inner.addEventListener('touchend', function(e) {
      if (!touchMoved || e.changedTouches.length !== 1) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = Math.abs(e.changedTouches[0].clientY - touchStartY);
      if (dy > SWIPE_MAX_VERT) return;            // mostly vertical → ignore
      if (Math.abs(dx) < SWIPE_MIN) return;       // not enough horizontal
      if (dx < 0) shiftLightbox(1);               // swipe left → next
      else        shiftLightbox(-1);              // swipe right → prev
    }, { passive: true });

    return lb;
  }

  var lbImages = [], lbIndex = 0;
  function openLightbox(images, index) {
    lbImages = images; lbIndex = index;
    var box = getLightbox();
    setLightboxImage(lbIndex);
    box.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    getLightbox().classList.remove('open');
    document.body.style.overflow = '';

    // 1. Reset main product images (clear any transform our code applied)
    document.querySelectorAll('.photo-zoom-link img:not(.zoomImg)').forEach(function (img) {
      img.style.transform = '';
      img.style.transformOrigin = '';
    });

    // 2. Force-hide the theme's elevateZoom overlay (.zoomImg). The plugin's
    //    own mouseleave doesn't fire when our lightbox is what closed, so the
    //    overlay can stay visible and look like the thumbnail is "stuck zoomed"
    document.querySelectorAll('.photo-zoom-link .zoomImg').forEach(function (zimg) {
      zimg.style.opacity = '0';
      zimg.style.display = 'none';
    });

    // 3. Tell elevateZoom (via jQuery mouseleave) to clean up its state
    if (typeof jQuery !== 'undefined') {
      jQuery('.photo-zoom-link').trigger('mouseleave');
    }
  }
  function setLightboxImage(i) {
    var img = document.getElementById('sobe-lb-img');
    img.style.opacity = '0';
    img.alt = '';
    img.src = lbImages[i] || '';
    img.onload  = function() { img.style.opacity = '1'; };
    img.onerror = function() {
      img.style.opacity = '0.4';
      img.alt = 'Image could not be loaded';
    };
    var prev = document.getElementById('sobe-lb-prev');
    var next = document.getElementById('sobe-lb-next');
    prev.style.visibility = lbImages.length > 1 ? 'visible' : 'hidden';
    next.style.visibility = lbImages.length > 1 ? 'visible' : 'hidden';
  }
  function shiftLightbox(dir) {
    lbIndex = (lbIndex + dir + lbImages.length) % lbImages.length;
    setLightboxImage(lbIndex);
  }

  // ── Hover pan zoom ──
  function getProductImg(wrap) {
    var imgs = wrap.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].classList.contains('zoomImg')) return imgs[i];
    }
    return null;
  }

  // Detect if the device has a real mouse hover. Touch-only devices return
  // `hover: none` and we skip the hover-zoom (which would otherwise stick
  // because mouseleave never fires on a tap).
  var supportsHover = !!(window.matchMedia && window.matchMedia('(hover: hover)').matches);

  function setupWrap(wrap, allImages, imgIndex) {
    if (initialized.has(wrap)) return;
    var img = getProductImg(wrap);
    if (!img) return;
    initialized.add(wrap);

    img.style.transition = 'transform 0.08s linear';
    img.style.willChange = 'transform';
    wrap.style.overflow = 'hidden';
    wrap.style.cursor = supportsHover ? 'crosshair' : 'zoom-in';

    // Zoom indicator — find existing or create. `hint` is always defined
    // (or `null` only when there's no parent at all) before mouseenter fires
    var imgWrap = wrap.parentElement;
    var hint = imgWrap ? imgWrap.querySelector('.sobe-zoom-hint') : null;
    if (imgWrap && !hint) {
      hint = document.createElement('div');
      hint.className = 'sobe-zoom-hint';
      hint.setAttribute('aria-hidden', 'true');
      hint.innerHTML = '<svg viewBox="0 0 18 18" width="11" height="11" fill="none" stroke="currentColor" stroke-width="2" style="display:inline-block;vertical-align:middle;margin-right:3px;"><circle cx="7.5" cy="7.5" r="5"/><line x1="11.5" y1="11.5" x2="16" y2="16"/><line x1="7.5" y1="5.5" x2="7.5" y2="9.5"/><line x1="5.5" y1="7.5" x2="9.5" y2="7.5"/></svg>Zoom';
      imgWrap.style.position = 'relative';
      imgWrap.appendChild(hint);
    }

    var zoomed = false;

    function getCursor(e) {
      var r = wrap.getBoundingClientRect();
      var src = e.touches ? e.touches[0] : e;
      var x = Math.max(0, Math.min(src.clientX - r.left, r.width));
      var y = Math.max(0, Math.min(src.clientY - r.top, r.height));
      var px = (x / r.width  * 100).toFixed(2) + '%';
      var py = (y / r.height * 100).toFixed(2) + '%';
      return { px: px, py: py };
    }

    // Only manage the hint visibility on hover devices — the actual hover
    // zoom is handled by the theme's elevateZoom plugin (which creates a
    // .zoomImg overlay). Our own transform: scale would conflict with it.
    if (supportsHover) {
      wrap.addEventListener('mouseenter', function () {
        if (hint) hint.style.opacity = '0';
      });
      wrap.addEventListener('mouseleave', function () {
        if (hint) hint.style.opacity = '1';
      });
    }

    // Click = lightbox
    wrap.addEventListener('click', function (e) {
      e.preventDefault();
      openLightbox(allImages, imgIndex);
    });
  }

  function initAll() {
    var sliders = document.querySelectorAll('[id^="ProductPhotos-"]');
    sliders.forEach(function (slider) {
      // Collect all high-res image URLs for the lightbox
      var allImages = [];
      slider.querySelectorAll('.photo-zoom-link').forEach(function (wrap) {
        var img = getProductImg(wrap);
        var zoomSrc = wrap.getAttribute('data-zoom-size') || (img && (img.src || img.getAttribute('data-src'))) || '';
        allImages.push(zoomSrc);
      });

      slider.querySelectorAll('.photo-zoom-link').forEach(function (wrap, idx) {
        setupWrap(wrap, allImages, idx);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(initAll, 600); });
  } else {
    setTimeout(initAll, 600);
  }

  // Re-init after thumbnail click or slide change
  document.addEventListener('click', function (e) {
    if (e.target.closest('.product__thumb')) setTimeout(initAll, 350);
  });
  document.addEventListener('afterChange', function () { setTimeout(initAll, 350); });
}());

jQuery(document).ready(function ($) {
  // sobeOwlInit (2026-09-05): product sliders used window.innerWidth breakpoints; on some Android phones the
  // width read at init is wrong and the slider comes up with the 4-per-row desktop layout (tiny items).
  // Fix: measure the slider's own container instead, and re-check after load / rotate / bfcache restore.
  function sobeOwlInit(sel, margin) {
    $(sel).each(function () {
      var el = this, $el = $(el), base = el.parentNode || window;
      var want = function () { var w = $(base).width() || window.innerWidth || 375; return w >= 1119 ? 4 : w >= 687 ? 3 : w >= 420 ? 2 : 1; };
      $el.owlCarousel({
        loop: true,
        margin: margin,
        responsiveClass: true,
        nav: true,
        dots: false,
        responsiveBaseElement: base,
        responsive: {
          0:    { center: false, items: 1 },
          420:  { center: false, items: 2 },
          687:  { center: true,  items: 3 },
          1119: { center: false, items: 4 }
        }
      });
      var fix = function () {
        var o = $el.data('owl.carousel');
        if (!o || !o.settings) return;
        if (o.settings.items !== want()) { try { $el.trigger('refresh.owl.carousel'); } catch (e) {} }
      };
      $(window).on('load orientationchange pageshow', function () { setTimeout(fix, 150); setTimeout(fix, 900); });
      setTimeout(fix, 1200); setTimeout(fix, 3000);
    });
  }
  sobeOwlInit(".collection-slider-inner", 10);
  $(".p_meta-slider").owlCarousel({
    items: 1,
    loop: true,
    responsiveClass: true,
    nav: false,
    dots: false,
  });
  sobeOwlInit(".p-slider", 20);

$('.video-btn').click(function(){
  $('.the-video').trigger('play');
  $('.the-video').attr('controls', '');
  $(this).css('display', 'none');
});

$(function () {

  var activeIndex = $('.active-tab').index(),
      $contentlis = $('.tabs-content > li'),
      $tabslis = $('.tabs li');
  
  // Show content of active tab on loads
  $contentlis.eq(activeIndex).show();

  $('.tabs').on('click', 'li', function (e) {
    var $current = $(e.currentTarget),
        index = $current.index();
    
    $tabslis.removeClass('active-tab');
    $current.addClass('active-tab');
    $contentlis.hide().eq(index).show();
	 });
});

// ── Mega menu hover (with grace period to bridge dropdown gap) ────────────
// The theme originally used a single-arg .hover() toggle which fires on
// BOTH mouseenter and mouseleave, with no delay. Combined with the 22px
// dead zone between .mega-hover and .mega-wrapper (top:154px), this caused
// the menu to flicker when the user moved their mouse from the nav link
// down to the submenu. Replace with proper enter/leave + 250ms grace.
$('.mega-hover').each(function () {
  var $el = $(this);
  var leaveTimer = null;
  var GRACE = 250; // ms — long enough to bridge the dead zone

  $el.on('mouseenter', function () {
    clearTimeout(leaveTimer);
    // Close any other open menus first
    $('.mega-hover').not($el).find('.mega-wrap-outer.display').removeClass('display');
    $el.find('.mega-wrap-outer').addClass('display');
  });

  $el.on('mouseleave', function () {
    clearTimeout(leaveTimer);
    leaveTimer = setTimeout(function () {
      $el.find('.mega-wrap-outer').removeClass('display');
    }, GRACE);
  });

  // If user re-enters the dropdown area itself, cancel the close timer
  $el.find('.mega-wrap-outer').on('mouseenter', function () {
    clearTimeout(leaveTimer);
  });
});

// ── Close mega menu on real user input only (no flicker) ─────────────────
// We deliberately DO NOT listen to `scroll` events because layout shifts
// (menu opening, header shrinking, dynamic content) fire phantom scroll
// events that close the menu mid-hover. Instead, listen to direct input:
// wheel, touchmove (for scrolling), and Escape (for keyboard).
(function () {
  var lastClose = 0;
  var COOLDOWN = 200; // ms: prevents close→reopen→close storms

  function closeMenus() {
    var now = Date.now();
    if (now - lastClose < COOLDOWN) return;
    lastClose = now;
    if (typeof $ !== 'undefined') {
      $('.mega-wrap-outer.display').stop(true, true).removeClass('display');
      $('.site-nav__dropdown-trigger.is-focused').removeClass('is-focused');
    }
    if (document.activeElement && document.activeElement.closest && document.activeElement.closest('.site-nav')) {
      document.activeElement.blur();
    }
  }

  // Mouse wheel = real user scroll intent
  window.addEventListener('wheel', closeMenus, { passive: true });

  // Touch scroll on mobile
  window.addEventListener('touchmove', closeMenus, { passive: true });

  // Keyboard navigation keys that move the page
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeMenus(); return; }
    var scrollKeys = ['PageUp', 'PageDown', 'Home', 'End', ' ', 'Spacebar'];
    if (scrollKeys.indexOf(e.key) !== -1) closeMenus();
    // ArrowUp/Down only count as scroll if no input is focused
    if ((e.key === 'ArrowUp' || e.key === 'ArrowDown') &&
        document.activeElement && document.activeElement.tagName !== 'INPUT' &&
        !(document.activeElement.closest && document.activeElement.closest('.mega-menu .mega-hover')) &&
        document.activeElement.tagName !== 'TEXTAREA' && document.activeElement.tagName !== 'SELECT') {
      closeMenus();
    }
  });
}());

});

const accordionItemHeaders = document.querySelectorAll(
  ".accordion-item-header"
);

accordionItemHeaders.forEach((accordionItemHeader) => {
  accordionItemHeader.addEventListener("click", (event) => {
    // Uncomment in case you only want to allow for the display of only one collapsed item at a time!

    const currentlyActiveAccordionItemHeader = document.querySelector(
      ".accordion-item-header.active"
    );
    if (
      currentlyActiveAccordionItemHeader &&
      currentlyActiveAccordionItemHeader !== accordionItemHeader
    ) {
      currentlyActiveAccordionItemHeader.classList.toggle("active");
      currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
    }
    accordionItemHeader.classList.toggle("active");
    const accordionItemBody = accordionItemHeader.nextElementSibling;
    if (accordionItemHeader.classList.contains("active")) {
      accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
    } else {
      accordionItemBody.style.maxHeight = 0;
    }
  });
});

// ── Scroll-shrink header ──────────────────────────────────────────────────
(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;

  var ticking   = false;
  // Read trigger distance from data attribute (set by section settings), fallback 55px
  var THRESHOLD = parseInt(header.getAttribute('data-sobe-trigger'), 10) || 55;
  // On mobile the header is smaller, so kick in sooner
  if (window.innerWidth < 768) THRESHOLD = Math.min(THRESHOLD, 35);

  function update() {
    var y = window.pageYOffset || document.documentElement.scrollTop;
    if (y >= THRESHOLD) {
      header.classList.add('sobe-shrunk');
    } else {
      header.classList.remove('sobe-shrunk');
    }
    ticking = false;
  }

  // Passive scroll listener + rAF throttle = zero layout-jank
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });

  // Apply correct state on initial load (e.g. page loaded mid-scroll)
  update();
}());

/* ─────────────────────────────────────────────────────────────────
   SoBe Image Protection + Staff Bypass
   Bypass URL: sobefurniture.com/?sobe-staff-aisearchcopy
   Cookie lasts 30 days. Visit bypass URL once per browser/device.
   NOTE: deliberately NO pointer-events:none — that breaks the carousel
───────────────────────────────────────────────────────────────── */
(function() {
  var BYPASS_PARAM = 'sobe-staff-aisearchcopy';
  var COOKIE_NAME  = 'sobe_staff_bypass';
  var COOKIE_DAYS  = 30;

  function setCookie(name, value, days) {
    var exp = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=1; expires=' + exp + '; path=/; SameSite=Lax';
  }
  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? m[1] : null;
  }

  /* Bypass URL → set cookie, clean URL, skip protection */
  if (new URLSearchParams(window.location.search).has(BYPASS_PARAM)) {
    setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
    var clean = new URL(window.location.href);
    clean.searchParams.delete(BYPASS_PARAM);
    window.history.replaceState({}, '', clean.pathname + (clean.search || '') + (clean.hash || ''));
    return;
  }

  /* Staff cookie present → refresh expiry and skip */
  if (getCookie(COOKIE_NAME) === '1') {
    setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
    return;
  }

  /* Block right-click sitewide. capture:true = fires before any theme handler */
  document.addEventListener('contextmenu', function(e) {
    e.preventDefault();
    return false;
  }, true);

  /* Block image dragging */
  document.addEventListener('dragstart', function(e) {
    if (e.target && e.target.tagName === 'IMG') e.preventDefault();
  }, true);

  /* Disable image drag/long-press save on iOS via CSS. NO pointer-events. */
  var s = document.createElement('style');
  s.textContent = 'img{-webkit-user-drag:none !important;user-drag:none !important;-webkit-touch-callout:none}';
  document.head.appendChild(s);
})();
/* End SoBe Image Protection */

// ── Smarter search: moved to assets/sobe-search.js (2026-10-09) ──────────────
// The old hook appended * to every word. Shopify now treats "lilly*" as a loose
// match: 893 of 904 products instead of the 6 Lilly pieces. sobe-search.js sends
// title-scoped queries instead and adds native prefix matching on the fallback.

/* ── SoBe: track Call + Get Directions clicks, sitewide (2026-09-05) ──────────
   Every tap on a tel: link or a google.com/maps link fires:
     1. GA4 event (click_to_call / click_to_get_directions) IF a Google tag exists on
        the page (it currently does not: the Google channel tag runs in Shopify's
        web-pixel sandbox, so window.gtag is undefined);
     2. Shopify.analytics.publish('sobe_cta_click') so a Custom Pixel can forward it;
     3. a beacon to the SoBe CTA counter (SOBE_CTA_ENDPOINT) - the source of truth
        for Frank's "are people hitting the buttons" question. No personal data:
        type, placement, page, traffic source, device, timestamp.                   */
(function () {
  if (window.__sobeCtaTrack) return;
  window.__sobeCtaTrack = true;
  window.__sobeDirTrack = true; /* supersedes the old directions-only listener */
  var SOBE_CTA_ENDPOINT = 'https://sobe-cta-counter.vercel.app/api/tap';
  function firstTouch() {
    try {
      var q = location.search || '';
      if (/[?&](gclid|gbraid|wbraid|gad_source|gad_campaignid)=/.test(q)) { sessionStorage.setItem('sobe_src', 'google_ads'); return; }
      if (sessionStorage.getItem('sobe_src')) return;
      var m = q.match(/[?&]utm_source=([^&]+)/);
      if (m) { sessionStorage.setItem('sobe_src', 'utm_' + decodeURIComponent(m[1]).toLowerCase().slice(0, 20)); return; }
      var r = document.referrer || '';
      var src = 'direct';
      if (!r) src = 'direct';
      else if (/sobefurniture\.com/.test(r)) return; /* internal navigation: keep waiting for a real first touch */
      else if (/google\./.test(r)) src = 'google_organic';
      else if (/bing\.|yahoo\.|duckduckgo/.test(r)) src = 'other_search';
      else if (/facebook|instagram|fb\.com|l\.instagram|tiktok|pinterest|t\.co/.test(r)) src = 'social';
      else if (/chatgpt|openai|perplexity|claude\.ai|gemini\.google|copilot/.test(r)) src = 'ai_assistant';
      else src = 'referral';
      sessionStorage.setItem('sobe_src', src);
    } catch (e) {}
  }
  firstTouch();
  function placement(a) {
    if (a.closest('.sobe-map')) return 'map';
    if (a.closest('.sobe-mcta')) return 'mobile_sticky_bar';
    if (a.closest('[id$="sobe_visit_cta"]') || a.closest('.sobe-visit-cta')) return 'visit_cta';
    if (a.closest('[id$="google_reviews_sobe"]')) return 'reviews_section';
    if (a.closest('.sobe-footer-nap')) return 'footer_bar';
    if (a.closest('.footer__collapsible') || a.closest('.site-footer')) return 'footer_column';
    if (a.closest('.contact-page') || /^\/pages\/contact/.test(location.pathname)) return 'contact_page';
    if (a.closest('.site-header') || a.closest('.header-wrapper')) return 'header';
    if (a.closest('.sbl-showroom') || a.closest('.sobe-showroom-link') || a.closest('.xlfb-showroom') || /^\/pages\//.test(location.pathname)) return 'landing_page';
    if (/^\/blogs\//.test(location.pathname)) return 'blog';
    if (/^\/products\//.test(location.pathname)) return 'product_page';
    return 'other';
  }
  function send(type, a) {
    var payload = {
      t: type,
      l: placement(a),
      p: location.pathname.slice(0, 120),
      s: (function () { try { return sessionStorage.getItem('sobe_src') || 'direct'; } catch (e) { return 'unknown'; } })(),
      d: (window.matchMedia && window.matchMedia('(max-width: 768px)').matches) ? 'mobile' : 'desktop',
      ts: new Date().toISOString()
    };
    try {
      var ev = type === 'call' ? 'click_to_call' : type === 'listing' ? 'click_to_view_listing' : 'click_to_get_directions';
      var params = { link_location: payload.l, page_path: payload.p, traffic_source: payload.s, device: payload.d };
      if (typeof gtag === 'function') gtag('event', ev, params);
      else if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(Object.assign({ event: ev }, params));
    } catch (e) {}
    try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) window.Shopify.analytics.publish('sobe_cta_click', payload); } catch (e) {}
    if (SOBE_CTA_ENDPOINT) {
      try {
        var body = JSON.stringify(payload);
        if (navigator.sendBeacon) navigator.sendBeacon(SOBE_CTA_ENDPOINT, new Blob([body], { type: 'text/plain' }));
        else fetch(SOBE_CTA_ENDPOINT, { method: 'POST', body: body, keepalive: true, mode: 'no-cors', headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
      } catch (e) {}
    }
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (/^tel:/i.test(href)) send('call', a);
    else if (/google\.[a-z.]+\/maps|maps\.app\.goo\.gl|goo\.gl\/maps/i.test(href)) {
      /* /maps/dir/ = real turn-by-turn request. /maps/search/ and place links only open the
         Google listing (e.g. "view all reviews"), which is not store-visit intent. */
      send(/\/maps\/dir\//i.test(href) ? 'directions' : 'listing', a);
    }
  }, true);
})();
/* End SoBe CTA tracking */

/* ── SoBe: open cookie preferences from any #privacy-choices link ── */
(function () {
  if (window.__sobePrivacyChoices) return;
  window.__sobePrivacyChoices = true;
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href="#privacy-choices"]') : null;
    if (!a) return;
    e.preventDefault();
    try {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
      } else if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.openBanner === 'function') {
        window.Shopify.customerPrivacy.openBanner();
      } else {
        window.location.href = 'mailto:sobefurniturewebsite@gmail.com?subject=Privacy%20request';
      }
    } catch (err) { }
  }, true);
})();

/* ── SoBe: Google Ads store-visit conversions (2026-09-17) ──────────────────────
   Appended to assets/custom.js after the "End SoBe CTA tracking" block.
   Needs window.SOBE_AW = { id, call, dir, lead } and gtag() from layout/theme.liquid.
   1. Wraps the existing CTA tracker: every tel: tap -> Ads conversion "call";
      every /maps/dir/ tap -> Ads conversion "directions" (listing links are ignored).
   2. Plan Your Visit / contact form: Shopify reloads the page with ?contact_posted=true
      after a successful post -> Ads conversion "lead" (once per browser session).
   No personal data is sent; only the conversion label.                              */
(function () {
  if (window.__sobeAwConv) return;
  window.__sobeAwConv = true;
  function fire(kind) {
    try {
      var cfg = window.SOBE_AW;
      if (!cfg || !cfg.id || !cfg[kind] || typeof gtag !== 'function') return;
      if (/XXXX|_LABEL/.test(cfg.id + cfg[kind])) return; /* placeholders not filled in yet */
      gtag('event', 'conversion', { send_to: cfg.id + '/' + cfg[kind] });
    } catch (e) {}
  }
  /* 1. call + directions taps (capture phase, same rules as the CTA counter) */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (/^tel:/i.test(href)) fire('call');
    else if (/google\.[a-z.]+\/maps\/dir\//i.test(href)) fire('dir');
  }, true);
  /* 2. form submitted (Shopify contact form success reload) */
  try {
    if (/[?&]contact_posted=true/.test(location.search)) {
      var key = 'sobe_lead_fired_' + location.pathname;
      if (!sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, '1');
        fire('lead');
      }
    }
  } catch (e) {}
})();
/* End SoBe Google Ads conversions */

/* ── SoBe: keep the sticky-header placeholder at the header's full height (2026-09-18) ──
   Bug: theme.js stickyHeaderHeight() sets .site-header-sticky height = header height on every
   window resize. If a resize fires while the header is scrolled and compressed (.sobe-shrunk,
   ~132px vs ~179px), the placeholder keeps the small height; back at the top the header grows
   again inside the short wrapper and the nav row disappears under the page content.
   Fix: remember the header's natural (un-shrunk) height and re-apply it to the wrapper after
   resizes, after the un-shrink transition, and whenever we are back at the top.            */
(function () {
  if (window.__sobeStickyFix) return;
  window.__sobeStickyFix = true;
  var header = document.querySelector('.site-header');
  if (!header) return;
  var naturalH = 0, timer;
  function wrap() { return document.querySelector('.site-header-sticky'); }
  function measure() {
    if (header.classList.contains('sobe-shrunk')) return;      /* never record the compressed height */
    var h = header.getBoundingClientRect().height;
    if (h > 40) naturalH = h;
  }
  function fix() {
    var w = wrap();
    if (!w || !naturalH) return;
    var cur = parseFloat(w.style.height) || 0;
    if (Math.abs(cur - naturalH) > 1) w.style.height = naturalH + 'px';
  }
  function later() { clearTimeout(timer); timer = setTimeout(function () { measure(); fix(); }, 120); } /* runs after theme's 50ms debounce */
  window.addEventListener('resize', later);
  window.addEventListener('orientationchange', later);
  var pending = false;
  window.addEventListener('scroll', function () {
    if (pending || header.classList.contains('sobe-shrunk')) return;
    pending = true;
    setTimeout(function () { pending = false; measure(); fix(); }, 500); /* after the 0.44s un-shrink transition */
  }, { passive: true });
  header.addEventListener('transitionend', function (e) {
    if (/padding|max-width/.test(e.propertyName)) { measure(); fix(); }
  });
  window.addEventListener('load', function () { setTimeout(function () { measure(); fix(); }, 300); });
  measure(); fix();
}());
/* End SoBe sticky-header placeholder fix */

/* ── SoBe: keyboard, touch and ARIA support for the header mega menus (2026-09-19) ──
   The hover script above opens/closes .mega-wrap-outer with the "display" class. This adds:
   - keyboard: focus moving into a menu item opens its panel, focus leaving closes it, Escape closes and returns focus
   - touch/pen: the first tap on a top-level link opens the panel instead of navigating; a second tap follows the link
     (decided from the pointer event, which fires before the browser's synthetic mouse events open the panel)
   - aria-expanded on the top-level link mirrors the real open state, whichever script changed it            */
(function () {
  if (window.__sobeMegaA11y) return;
  window.__sobeMegaA11y = true;
  var items = Array.prototype.slice.call(document.querySelectorAll('.mega-menu .mega-hover'));
  if (!items.length) return;
  function parts(item) {
    var link = null, wrap = null, c = item.children;
    for (var i = 0; i < c.length; i++) {
      if (!link && c[i].classList.contains('mega-link')) link = c[i];
      if (!wrap && c[i].classList.contains('mega-wrap-outer')) wrap = c[i];
    }
    return { item: item, link: link, wrap: wrap, suppress: false, touchWasOpen: null };
  }
  function isOpen(p) { return !!(p.wrap && p.wrap.classList.contains('display')); }
  function setOpen(p, open) {
    if (!p.wrap) return;
    p.wrap.classList.toggle('display', !!open);
    if (p.link) p.link.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeOthers(p) { all.forEach(function (o) { if (o !== p) setOpen(o, false); }); }
  var all = items.map(parts).filter(function (p) { return p.wrap && p.link; });
  all.forEach(function (p) {
    var item = p.item;
    p.link.setAttribute('aria-expanded', 'false');
    if (p.wrap.id) p.link.setAttribute('aria-controls', p.wrap.id);

    /* keyboard */
    item.addEventListener('focusin', function () {
      if (p.suppress) return;
      closeOthers(p);
      setOpen(p, true);
    });
    item.addEventListener('focusout', function (e) {
      if (!e.relatedTarget || !item.contains(e.relatedTarget)) setOpen(p, false);
    });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        p.suppress = true;
        setOpen(p, false);
        p.link.focus();
        p.suppress = false;
      }
    });

    /* touch and pen: snapshot the open state before synthetic mouse events run */
    p.link.addEventListener('pointerdown', function (e) {
      p.touchWasOpen = (e.pointerType === 'touch' || e.pointerType === 'pen') ? isOpen(p) : null;
    });
    p.link.addEventListener('click', function (e) {
      if (p.touchWasOpen === false) {
        e.preventDefault();
        closeOthers(p);
        setOpen(p, true);
      }
      p.touchWasOpen = null;
    });

    /* keep aria-expanded truthful when the hover script or the close-on-input script toggles the class */
    if (window.MutationObserver) {
      new MutationObserver(function () { p.link.setAttribute('aria-expanded', isOpen(p) ? 'true' : 'false'); })
        .observe(p.wrap, { attributes: true, attributeFilter: ['class'] });
    }
  });

  /* a tap or click anywhere outside the nav closes any open panel (mouse users are handled by the hover script) */
  document.addEventListener('pointerup', function (e) {
    if (e.pointerType === 'mouse') return;
    if (!e.target.closest || !e.target.closest('.mega-menu .mega-hover')) all.forEach(function (o) { setOpen(o, false); });
  }, { passive: true });

  /* Lifestyle tiles are lazy so they cost nothing on page load; start fetching them as soon as the
     visitor shows intent on the nav bar, so they are painted by the time the panel opens. */
  var nav = document.querySelector('.mega-menu');
  if (nav) {
    var warmed = false;
    function warm() {
      if (warmed) return;
      warmed = true;
      var imgs = nav.querySelectorAll('.mega-wrapper--outdoor img[loading="lazy"]');
      for (var i = 0; i < imgs.length; i++) imgs[i].loading = 'eager';
    }
    ['mouseenter', 'focusin', 'touchstart', 'pointerdown'].forEach(function (ev) { nav.addEventListener(ev, warm, { passive: true, once: true }); });
    /* desktop only (the nav is hidden under 1200px): fetch the tiles once the page has finished loading */
    if (window.matchMedia && window.matchMedia('(min-width: 1200px)').matches) {
      var idle = function () { setTimeout(warm, 1500); };
      if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle, { once: true });
    }
  }
}());
/* End SoBe mega-menu keyboard support */

/* ── SoBe: Synchrony online application opens on top of the page (2026-10-03) ──────
   Synchrony's apply.syf.com refuses to be embedded (frame-ancestors 'none' + X-Frame-Options
   DENY), so links marked data-sobe-apply open it in a centred window over the page on desktop
   and in a new tab on phones/tablets; either way the SoBe page never navigates away. Without JS
   (or if the popup is blocked) the link's own target="_blank" does the same.                  */
(function () {
  if (window.__sobeApplyPopup) return;
  window.__sobeApplyPopup = true;
  var pop = null; /* the open application window, so a second click focuses it instead of opening another */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[data-sobe-apply]') : null;
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (!(window.matchMedia && window.matchMedia('(min-width: 900px) and (pointer: fine)').matches)) return;
    if (pop && !pop.closed) { e.preventDefault(); try { pop.focus(); } catch (err) {} return; }
    var w = Math.min(640, (screen.availWidth || 1024) - 40), h = Math.min(920, (screen.availHeight || 800) - 60);
    var x = (window.screenX || 0) + Math.max(0, ((window.outerWidth || w) - w) / 2);
    var y = (window.screenY || 0) + Math.max(0, ((window.outerHeight || h) - h) / 2);
    var win = null;
    try { win = window.open('', 'sobe_synchrony_apply', 'popup=yes,width=' + w + ',height=' + h + ',left=' + Math.round(x) + ',top=' + Math.round(y)); } catch (err) {}
    if (!win || win.closed) return; /* blocked: let the link open its normal new tab */
    e.preventDefault();
    var started = false;
    try { started = win.location.href !== 'about:blank'; } catch (err) { started = true; } /* cross-origin = already on Synchrony */
    if (!started) {
      try { win.opener = null; } catch (err) {}
      win.location.href = a.href;
    }
    pop = win;
    try { win.focus(); } catch (err) {}
  });
})();
/* End SoBe Synchrony apply */

/* ── SoBe: tell us what the customer was looking at (2026-10-05) ──────────────────────────
   Frank got a contact-form message about "a wall unit" with no way to know which one. Every
   Shopify contact form on the site now carries hidden fields that land in the notification email:
     Product asked about  - from ?product= (Request a Quote buttons) or the product page itself
     Sent from page       - the page the form was submitted on
     Recently viewed      - the last 5 products this browser looked at (last 14 days), with links
   Viewed products are kept only in this browser's localStorage.                                   */
(function () {
  if (window.__sobeLeadCtx) return;
  window.__sobeLeadCtx = true;
  var KEY = 'sobe_viewed', MAXN = 5, MAXAGE = 14 * 864e5;
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function save(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  var now = Date.now();
  var list = load().filter(function (x) { return x && x.u && now - x.ts < MAXAGE; });
  var onProduct = /^\/(collections\/[^/]+\/)?products\//.test(location.pathname);
  var productTitle = '';
  if (onProduct && !/404|not found/i.test(document.title)) {
    var h1 = document.querySelector('h1.product-single__title, .product-single__meta h1, h1');
    productTitle = (h1 && h1.textContent || document.title.split('|')[0] || '').replace(/\s+/g, ' ').trim();
    var path = '/products/' + location.pathname.split('/products/')[1].split('/')[0];
    list = list.filter(function (x) { return x.u !== path; });
    list.unshift({ t: productTitle, u: path, ts: now });
    list = list.slice(0, MAXN); save(list);
  }
  var qs = new URLSearchParams(location.search);
  var asked = qs.get('product') || (onProduct ? productTitle : '');
  function addHidden(form, name, value) {
    if (!value) return;
    var el = form.querySelector('input[name="contact[' + name + ']"]');
    if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = 'contact[' + name + ']'; form.appendChild(el); }
    el.value = value;
  }
  function fill() {
    var forms = document.querySelectorAll('form');
    for (var i = 0; i < forms.length; i++) {
      var f = forms[i], ft = f.querySelector('input[name="form_type"]');
      if (!ft || ft.value !== 'contact') continue;
      addHidden(f, 'Product asked about', asked);
      addHidden(f, 'Sent from page', 'https://sobefurniture.com' + location.pathname + location.search);
      addHidden(f, 'Recently viewed', list.map(function (x) { return x.t + ' - https://sobefurniture.com' + x.u; }).join('  |  '));
    }
    // Request a Quote lands here as ?product=<title>: start the message for them (only if empty)
    if (qs.get('product')) {
      var box = document.querySelector('textarea[name="contact[body]"]');
      if (box && !box.value) box.value = 'Hi SoBe, I would like a quote on the ' + qs.get('product') + '. ';
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fill); else fill();
  document.addEventListener('submit', function (e) { if (e.target && e.target.querySelector && e.target.querySelector('input[name="form_type"][value="contact"]')) fill(); }, true);
})();
/* End SoBe lead context */
